import {
  GET_ORGANIZATIONS_OVERVIEW_ERROR,
  GET_ORGANIZATIONS_OVERVIEW_START,
  GET_ORGANIZATIONS_OVERVIEW_SUCCESS,
} from 'constants/action-types/organizations/organizationsOverview';

export default (state, { type, payload }) => {
  switch (type) {
    case GET_ORGANIZATIONS_OVERVIEW_START:
      return {
        ...state,
        organizationsOverview: {
          ...state.organizationsOverview,
          loading: true,
          error: null,
        },
      };
    case GET_ORGANIZATIONS_OVERVIEW_SUCCESS:
      return {
        ...state,
        organizationsOverview: {
          ...state.organizationsOverview,
          loading: false,
          data: payload.data,
        },
      };
    case GET_ORGANIZATIONS_OVERVIEW_ERROR:
      return {
        ...state,
        organizationsOverview: {
          ...state.organizationsOverview,
          loading: false,
          error: payload,
        },
      };
    default:
      return null;
  }
};
